export default __webpack_public_path__ + "static/components-812d57934c4e55089168a69554790496.png";